/**
 * 键盘设备配置文件
 * 管理不同型号键盘的 VID/PID 和样式配置
 */


export const keyboardDevices = [
    {
        name: 'US Standard',
        vendorId: 0x5548,
        productId: 0x1025,
        modelId: 'k1',
        linkMode: 'wired',
        region: 'us',
        styleClass: 'keyboard-us',
        version: 'k1Pro'
    },
    {
        name: 'US Standard',
        vendorId: 0x6603,
        productId: 0x1015,
        modelId: 'k1',
        linkMode: 'wired',
        region: 'us',
        styleClass: 'keyboard-us',
        version: 'k1Pro'
    },
    {
        name: 'EU Standard',
        vendorId: 0x6603,
        productId: 0x1019,
        modelId: 'k1',
        linkMode: 'wired',
        region: 'eu',
        styleClass: 'keyboard-eu',
        version: 'k1Pro'
    },
    {
        name: 'US Standard',
        // vendorId: 9999,
        // productId: 1111,
        vendorId: 0x6603,
        productId: 0x1021,
        modelId: 'k1',
        linkMode: 'wireless',
        region: 'us',
        styleClass: 'keyboard-us',
        version: 'k1-W'
    },
    {
        name: 'US Standard',
        vendorId: 0x6603,
        productId: 0x1020,
        modelId: 'k1',
        linkMode: 'wired',
        region: 'us',
        styleClass: 'keyboard-us',
        version: 'k1-W'
    },
];

/**
 * 根据 VID/PID 获取设备配置
 */
export function getDeviceConfig(vendorId, productId) {
    return keyboardDevices.find(
        device => device.vendorId === vendorId && device.productId === productId
    );
}

/**
 * 根据 VID/PID 推断连接模式（wired / wireless）
 */
export function getDeviceLinkMode(vendorId, productId) {
    const config = getDeviceConfig(vendorId, productId)
    if (!config) return null
    if (config.linkMode) return config.linkMode
    return config.version ? 'wireless' : 'wired'
}

/**
 * 根据当前设备查找同型号的配对模式设备（例如 wired -> wireless）
 */
export function getPairedDeviceConfig(vendorId, productId, targetMode) {
    const current = getDeviceConfig(vendorId, productId)
    if (!current || !current.modelId || !targetMode) return null

    return keyboardDevices.find(device =>
        device.modelId === current.modelId &&
        device.linkMode === targetMode &&
        !(device.vendorId === vendorId && device.productId === productId)
    ) || null
}

/**
 * 获取所有设备的过滤器格式（用于 requestDevice）
 */
export function getDeviceFilters() {
    return keyboardDevices.map(device => ({
        vendorId: device.vendorId,
        productId: device.productId
    }));
}
